import React, { useEffect, useState } from "react";
import Page from "../../component/Page";
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  Menu,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { MobileDatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { getBranchList } from "../setting/services/settingApi";
import api from "../../api/api";
import { saveAs } from "file-saver";
import { REPORT_CONFIG } from "./config";
import { getData } from "../../services/api";

const BrowserInput = function BrowserInput(props) {
  const { inputProps, InputProps, ownerState, value, inputRef, error, ...other } = props;
  return (
    <TextField
      {...inputProps}
      ref={inputRef}
      value={
        value
          ? value.substring(0, value?.length - 6) +
            (parseInt(value?.substring(value?.length - 6)) + 543).toString()
          : null
      }
      {...other}
      variant="standard"
      fullWidth
      InputProps={{ disableUnderline: true }}
    />
  );
};

export default function ReportMaterialProduction() {
  const [branchs, setBranchs] = useState([]);
  const [materials, setMaterials] = useState([]);
  const [BranchNo, setBranchsNo] = useState("");
  const [MaterialNo, setMaterialNo] = useState("");
  const [BudgetYear, setBudgetYear] = useState("");
  const [startDate, setStartDate] = useState(dayjs(new Date()).startOf("year"));
  const [endDate, setEndDate] = useState(dayjs(new Date()));

  const [reports, setReports] = useState([]);
  const [loadingDownload, setloadingDownload] = useState(false);
  const [loading, setloading] = useState(false);

  const { profile } = useSelector((state) => state.profile);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const getMaterials = async () => {
    const res = await getData("dbms/materials");
    setMaterials(res.result);
  };

  useEffect(() => {
    getBranchList(null, setBranchs);
    getMaterials();
  }, []);

  async function getMaterialProductionReport(body, mode, format) {
    const url = `${REPORT_CONFIG.requests.materialProductionReport.url}/${mode}`;

    let params = {
      sdate: body.sdate,
      edate: body.edate,
    };
    if (body.branchNo && body.branchNo !== "-")
      params = { ...params, branchNo: body.branchNo };
    if (body.materialCatalogNo && body.materialCatalogNo !== "-")
      params = { ...params, materialCatalogNo: body.materialCatalogNo };
    if (body.budgetYear) params = { ...params, budgetYear: body.budgetYear };
    if (format) params = { ...params, format: format };

    if (mode === "file") {
      setloadingDownload(true);
      const res = await api.get(url, {
        params: params,
        responseType: "arraybuffer",
      });
      const data = res.data;
      if (format) {
        const blob = new Blob([data], { type: "application/pdf" });
        saveAs(blob, "รายงานวัสดุการผลิต");
      } else {
        const blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, "รายงานวัสดุการผลิต");
      }
      setloadingDownload(false);
    } else {
      setloading(true);
      const res = await api.get(url, { params: params });
      const data = res.data.result;
      setReports(data);
      setloading(false);
    }
  }

  function buildBody() {
    return {
      sdate: startDate ? dayjs(startDate).format("YYYY-MM-DD") : "",
      edate: endDate ? dayjs(endDate).format("YYYY-MM-DD") : "",
      branchNo: BranchNo || undefined,
      materialCatalogNo: MaterialNo || undefined,
      budgetYear: BudgetYear || undefined,
    };
  }

  async function LoadReport() {
    getMaterialProductionReport(buildBody(), "data");
  }

  return (
    <div style={{ padding: "10px 30px" }}>
      <Page>
        <div class="container-fluid p-0">
          <form>
            <div class="row  no-gutters">
              <div class="col-12 col-lg-2">
                <div class="row no-gutters">
                  <div class="col-12 header-row border-1 ">ตัวกรอง</div>
                </div>
                <div class="row no-gutters p-2 border-1">
                  <div class="col-12">
                    <label class="labelInput">วันที่เริ่มต้น</label>
                    <Box
                      className="backgroundField"
                      sx={{ marginBottom: "20px", borderRadius: "25px" }}
                    >
                      <MobileDatePicker
                        dayOfWeekFormatter={(day) => `${day}`}
                        value={startDate}
                        onChange={(e) => setStartDate(e)}
                        slotProps={{
                          textField: {
                            variant: "standard",
                            fullWidth: true,
                            InputProps: { disableUnderline: true },
                            value: startDate,
                          },
                        }}
                        slots={{ textField: BrowserInput }}
                      />
                    </Box>
                  </div>
                  <div class="col-12">
                    <label class="labelInput">วันที่สิ้นสุด</label>
                    <Box
                      className="backgroundField"
                      sx={{ marginBottom: "20px", borderRadius: "25px" }}
                    >
                      <MobileDatePicker
                        dayOfWeekFormatter={(day) => `${day}`}
                        value={endDate}
                        onChange={(e) => setEndDate(e)}
                        slotProps={{
                          textField: {
                            variant: "standard",
                            fullWidth: true,
                            InputProps: { disableUnderline: true },
                            value: endDate,
                          },
                        }}
                        slots={{ textField: BrowserInput }}
                      />
                    </Box>
                  </div>
                  {profile?.BranchNo?.BranchNo === "00" && (
                    <div class="col-12">
                      <label class="labelInput">ศูนย์เมล็ดพันธุ์ข้าว</label>
                      <Box
                        className="backgroundField"
                        sx={{ marginBottom: "10px" }}
                      >
                        <FormControl variant="standard" fullWidth>
                          <Select
                            value={BranchNo || "-"}
                            onChange={(e) => setBranchsNo(e.target.value)}
                            disableUnderline
                          >
                            <MenuItem value="-">-</MenuItem>
                            {branchs?.map((x) => (
                              <MenuItem value={x?.BranchNo}>
                                {x?.BranchName}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Box>
                    </div>
                  )}
                  <div class="col-12">
                    <label class="labelInput">รายการวัสดุ</label>
                    <Box
                      className="backgroundField"
                      sx={{ marginBottom: "10px" }}
                    >
                      <FormControl variant="standard" fullWidth>
                        <Select
                          value={MaterialNo || "-"}
                          onChange={(e) => setMaterialNo(e.target.value)}
                          disableUnderline
                        >
                          <MenuItem value="-">-</MenuItem>
                          {materials?.map((x) => (
                            <MenuItem value={x?.ItemNo}>{x?.ItemName}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Box>
                  </div>
                  <div class="col-12">
                    <label class="labelInput">ปีงบประมาณ</label>
                    <Box
                      className="backgroundField"
                      sx={{ marginBottom: "20px" }}
                    >
                      <TextField
                        variant="standard"
                        fullWidth
                        value={BudgetYear}
                        onChange={(e) => setBudgetYear(e.target.value)}
                        InputProps={{ disableUnderline: true }}
                      />
                    </Box>
                  </div>
                  <div class="col-12">
                    <Button
                      onClick={LoadReport}
                      disabled={loading ? true : false}
                      variant="contained"
                      className="ButtomSearch"
                    >
                      {loading ? (
                        <CircularProgress size={"18px"} color="inherit" />
                      ) : (
                        "ค้นหา"
                      )}{" "}
                    </Button>
                  </div>
                </div>
              </div>
              <div class="col-12 col-lg-10">
                <div class="row no-gutters">
                  <div class="col-12 d-flex justify-content-between header-row border-1 ">
                    <div>รายงานวัสดุการผลิต</div>
                    <Button
                      variant="contained"
                      id="basic-button"
                      aria-controls={open ? "basic-menu" : undefined}
                      aria-haspopup="true"
                      aria-expanded={open ? "true" : undefined}
                      disabled={loadingDownload ? true : false}
                      onClick={handleClick}
                    >
                      {loadingDownload ? (
                        <CircularProgress size={"18px"} color="inherit" />
                      ) : (
                        "ดาวน์โหลด"
                      )}
                    </Button>
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      MenuListProps={{ "aria-labelledby": "basic-button" }}
                      PaperProps={{ style: { width: 100 } }}
                    >
                      <MenuItem
                        onClick={() => {
                          getMaterialProductionReport(buildBody(), "file");
                          handleClose();
                        }}
                      >
                        Excel
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          getMaterialProductionReport(buildBody(), "file", "pdf");
                          handleClose();
                        }}
                      >
                        Pdf
                      </MenuItem>
                    </Menu>
                  </div>
                </div>
                <div class="row no-gutters border-1 pt-3">
                  <div class="report col-12">
                    <div class="table-responsive-sm" style={{ height: "auto" }}>
                      <table class="table table-bordered table-sm table-hover">
                        <thead class="sticky-thead">
                          <tr>
                            <th scope="col" rowspan="2">ศูนย์เมล็ดพันธุ์ข้าว</th>
                            <th scope="col" rowspan="2">รายการ</th>
                            <th scope="col" rowspan="2">หน่วย</th>
                            <th scope="col" rowspan="2">ประเภทเงินที่จัดซื้อ/จัดทำ</th>
                            <th scope="col" rowspan="2">ปีงบประมาณที่จัดซื้อ/จัดทำ</th>
                            <th scope="col" rowspan="2">เลขครุภัณฑ์</th>
                            <th scope="col" rowspan="2">ราคาต้นทุนตามบัญชี ราคา/หน่วย (บาท)</th>
                            <th scope="col" colspan="7">วัสดุคงคลัง</th>
                            <th scope="col" rowspan="2">คงเหลือ</th>
                            <th scope="col" rowspan="2">อายุการใช้งาน</th>
                            <th scope="col" rowspan="2">สถานะ</th>
                            <th scope="col" rowspan="2">ขนาด</th>
                            <th scope="col" rowspan="2">หมายเหตุ</th>
                          </tr>
                          <tr>
                            <th scope="col">คงเหลือยกมา</th>
                            <th scope="col">ปริมาณรับ</th>
                            <th scope="col">รับโอน</th>
                            <th scope="col">ปริมาณจ่าย</th>
                            <th scope="col">ปริมาณคืน</th>
                            <th scope="col">โอนให้</th>
                            <th scope="col">ปริมาณยืม</th>
                          </tr>
                        </thead>
                        <tbody>
                          {reports?.map((report, i) => (
                            <tr class="cp">
                              <td class="text-center">{report?.BranchName || "-"}</td>
                              <td class="text-center">{report?.ItemName || "-"}</td>
                              <td class="text-center">{report?.UnitName || "-"}</td>
                              <td class="text-center">{report?.BudgetType || "-"}</td>
                              <td class="text-center">{report?.BudgetYear || "-"}</td>
                              <td class="text-center">{report?.Lot || "-"}</td>
                              <td class="text-end">{(+report?.CostPrice).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                              <td class="text-end">{(+report?.OpeningBalance).toLocaleString()}</td>
                              <td class="text-end">{(+report?.ReceiveQty).toLocaleString()}</td>
                              <td class="text-end">{(+report?.TransferInQty).toLocaleString()}</td>
                              <td class="text-end">{(+report?.ExpenseQty).toLocaleString()}</td>
                              <td class="text-end">{(+report?.ReturnQty).toLocaleString()}</td>
                              <td class="text-end">{(+report?.TransferOutQty).toLocaleString()}</td>
                              <td class="text-end">{(+report?.LendQty).toLocaleString()}</td>
                              <td class="text-end">{(+report?.RemainingBalance).toLocaleString()}</td>
                              <td class="text-center">{report?.Age}</td>
                              <td class="text-center">{report?.Status || "-"}</td>
                              <td class="text-center">{report?.Size || "-"}</td>
                              <td class="text-center">{report?.Remark || "-"}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                {reports.length === 0 && (
                  <div class="row">
                    <div class="col-12">
                      <div class="not-found">ไม่พบข้อมูล</div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </form>
        </div>
      </Page>
    </div>
  );
}
